/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable linebreak-style */
/* eslint-disable eol-last */
/* eslint-disable*/
import React, { useState, useEffect } from "react";
import { Card, Row, Col, message, Spin, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import {
    DropDownComponent,
    TableComponent,
    CalendarComponent,
} from "../../CommonComponents";
import "../styles.scss";
import Heading from "../../../../components/Heading";
import { ReportsService } from "../../../../services/api/reports";
import { downloadControlTowerReportA3 } from "../../../../utils/downloadUtils";
import { getHubList } from "../../../../services/api/hub";
import { useRequestCancellation } from "../../../../hooks/useRequestCancellation";

const ControlTowerReportsNew = () => {
    const { createNewRequest, isLatestRequest } = useRequestCancellation();

    // Set default date range to last 2 days
    const defaultDateRange = [
        moment().subtract(2, "days"),
        moment()
    ];

    const [loading, setLoading] = useState(false);
    const [hubListLoading, setHubListLoading] = useState(false);
    const [dateRange, setDateRange] = useState(defaultDateRange);
    const [latestStatusDateRange, setLatestStatusDateRange] = useState([]);
    const [hubList, setHubList] = useState([]);
    const [selectedOriginHubs, setSelectedOriginHubs] = useState([]);
    const [selectedDestinationHubs, setSelectedDestinationHubs] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [movementType, setMovementType] = useState([]);
    const [isClosed, setIsClosed] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    });
    const [reportData, setReportData] = useState([]);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [hubUser, setHubUser] = useState();

    // Status options - using dynamic list from API
    const [statusOptions, setStatusOptions] = useState([]);
    const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
    const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
    const [loadingCurrentHubs, setLoadingCurrentHubs] = useState(false);
    const [currentHubOptions, setCurrentHubOptions] = useState([]);
    const [selectedCurrentHubs, setSelectedCurrentHubs] = useState([]);
    const [lastTerminalStatusDateRange, setLastTerminalStatusDateRange] = useState([]);
    const [selectedLastTerminalStatuses, setSelectedLastTerminalStatuses] = useState([]);

    // Check user role and set default hub
    // Check user role and set default hub
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userinfo"));
        let userid = JSON.parse(localStorage.getItem("userId"));
        setHubUser(user?.roles?.[0]);
        // Set default current location for ROLE_HUBADMIN and ROLE_HUBOPERATOR
        const activeHub = JSON.parse(localStorage.getItem("active_hub"));
        const activeHubId = activeHub?.hubId;

        if (currentHubOptions.length > 0) {
            if (activeHubId) {
                const defaultHub = currentHubOptions.find((hub) => String(hub.value) === String(activeHubId));
                if (defaultHub) {
                    setSelectedCurrentHubs([defaultHub.value]);
                }
            } else if (user?.roles?.[0] === "ROLE_HUBADMIN" || user?.roles?.[0] === "ROLE_HUBOPERATOR") {
                const defaultHub = currentHubOptions.find(hub => String(hub.value) === String(userid?.userInfo?.premiseId));
                if (defaultHub) {
                    setSelectedCurrentHubs([defaultHub.value]);
                }
            }
        }
    }, [currentHubOptions]);

    // Fetch hub list and status list on mount
    useEffect(() => {
        (async () => {
            try {
                setHubListLoading(true);
                setLoadingCurrentHubs(true);
                const [hubs, statuses, serviceTypes, currentHubs] = await Promise.all([
                    getHubList(),
                    ReportsService.getControlTowerStatusList(),
                    ReportsService.getControlTowerServiceTypeList(),
                    ReportsService.getControlTowerCurrentHubList()
                ]);
                setHubList(hubs);
                setStatusOptions(statuses);
                setServiceTypeOptions(serviceTypes);
                setCurrentHubOptions(currentHubs);
            } catch {
                message.error("Failed to fetch initial data");
            } finally {
                setHubListLoading(false);
                setLoadingCurrentHubs(false);
            }
        })();
    }, []);

    // Fetch report data when filters or pagination change
    useEffect(() => {
        // Wait for hub user to be determined to avoid double fetching or missing default hub
        if (!hubUser && localStorage.getItem("userinfo")) return;

        // If user is Hub Admin or Operator, strictly wait for selectedCurrentHubs to be populated
        if ((hubUser === "ROLE_HUBADMIN" || hubUser === "ROLE_HUBOPERATOR") && selectedCurrentHubs.length === 0) {
            return;
        }

        fetchReport();
        // eslint-disable-next-line
    }, [selectedStatus, selectedOriginHubs, dateRange, latestStatusDateRange, selectedDestinationHubs, movementType, isClosed, selectedServiceTypes, selectedCurrentHubs, lastTerminalStatusDateRange, selectedLastTerminalStatuses, pagination.current, pagination.pageSize, hubUser]);

    const fetchReport = async () => {
        const { signal, requestId } = createNewRequest("control-tower-report-new");

        setLoading(true);
        try {
            const params = {
                ...(dateRange?.[0] && { fromDate: dateRange[0].format("YYYY-MM-DD") }),
                ...(dateRange?.[1] && { toDate: dateRange[1].format("YYYY-MM-DD") }),
                ...(latestStatusDateRange?.[0] && { latestStatusTimeFrom: latestStatusDateRange[0].format("YYYY-MM-DD") }),
                ...(latestStatusDateRange?.[1] && { latestStatusTimeTo: latestStatusDateRange[1].format("YYYY-MM-DD") }),
                ...(selectedStatus?.length > 0 && { status: selectedStatus }),
                ...(selectedOriginHubs?.length > 0 && { originHubIds: selectedOriginHubs }),
                ...(selectedDestinationHubs?.length > 0 && { destinationHubIds: selectedDestinationHubs }),
                ...(selectedCurrentHubs?.length > 0 && { currentHubIds: selectedCurrentHubs }),
                ...(movementType?.length > 0 && { movementTypes: movementType }),
                ...(selectedServiceTypes?.length > 0 && { serviceTypes: selectedServiceTypes }),

                ...(isClosed?.length > 0 && { isClosedList: isClosed }),
                ...(lastTerminalStatusDateRange?.[0] && { lastTerminalStatusTimeFrom: lastTerminalStatusDateRange[0].format("YYYY-MM-DD") }),
                ...(lastTerminalStatusDateRange?.[1] && { lastTerminalStatusTimeTo: lastTerminalStatusDateRange[1].format("YYYY-MM-DD") }),
                ...(selectedLastTerminalStatuses?.length > 0 && { lastTerminalStatuses: selectedLastTerminalStatuses }),
                page: pagination.current - 1, // API expects 0-based pagination
                size: pagination.pageSize
            };

            const { data, total, page, pageSize } = await ReportsService.getControlTowerReportA3(params, { signal });

            // Check if this is still the latest request
            if (!isLatestRequest(requestId)) {
                return;
            }

            setReportData(data);
            setPagination(prev => ({
                ...prev,
                total,
                current: page + 1, // Convert back to 1-based for UI
                pageSize
            }));

        } catch (error) {
            if (!isLatestRequest(requestId)) {
                return;
            }

            if (error.name === "AbortError") {
                return;
            }

            console.error("Error fetching report data:", error);
            message.error("Failed to fetch report data");
            setReportData([]);
            setPagination(prev => ({
                ...prev,
                total: 0
            }));
        } finally {
            if (isLatestRequest(requestId)) {
                setLoading(false);
            }
        }
    };


    const handleTableChange = (newPagination) => {
        setPagination(prev => ({
            ...prev,
            current: newPagination.current,
            pageSize: newPagination.pageSize
        }));
    };

    const handleDownload = async () => {
        try {
            setDownloadLoading(true);

            const params = {
                ...(dateRange?.[0] && { fromDate: dateRange[0].format("YYYY-MM-DD") }),
                ...(dateRange?.[1] && { toDate: dateRange[1].format("YYYY-MM-DD") }),
                ...(latestStatusDateRange?.[0] && { latestStatusTimeFrom: latestStatusDateRange[0].format("YYYY-MM-DD") }),
                ...(latestStatusDateRange?.[1] && { latestStatusTimeTo: latestStatusDateRange[1].format("YYYY-MM-DD") }),
                ...(selectedStatus?.length > 0 && { status: selectedStatus }),
                ...(selectedOriginHubs?.length > 0 && { originHubIds: selectedOriginHubs }),
                ...(selectedDestinationHubs?.length > 0 && { destinationHubIds: selectedDestinationHubs }),
                ...(selectedCurrentHubs?.length > 0 && { currentHubIds: selectedCurrentHubs }),
                ...(movementType?.length > 0 && { movementTypes: movementType }),
                ...(selectedServiceTypes?.length > 0 && { serviceTypes: selectedServiceTypes }),

                ...(isClosed?.length > 0 && { isClosedList: isClosed }),
                ...(lastTerminalStatusDateRange?.[0] && { lastTerminalStatusTimeFrom: lastTerminalStatusDateRange[0].format("YYYY-MM-DD") }),
                ...(lastTerminalStatusDateRange?.[1] && { lastTerminalStatusTimeTo: lastTerminalStatusDateRange[1].format("YYYY-MM-DD") }),
                ...(selectedLastTerminalStatuses?.length > 0 && { lastTerminalStatuses: selectedLastTerminalStatuses }),
            };

            await downloadControlTowerReportA3(params);
            message.success("Download started successfully");

        } catch (error) {
            console.error("Download error:", error);
            message.error("Failed to start download");
        } finally {
            setDownloadLoading(false);
        }
    };

    // Table columns based on API response
    const columns = [
        {
            title: "No.",
            dataIndex: "index",
            key: "index",
            width: 70,
            align: "center",
            render: (_, __, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
        },
        { title: "Booking Date/Time", dataIndex: "bookingDateTime", key: "bookingDateTime", width: 160, align: "center" },
        {
            title: "Tracking ID",
            dataIndex: "trackingId",
            key: "trackingId",
            width: 140,
            align: "center",
            render: (text) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        const url = `/shipment-tracker?awb=${text}`;
                        window.open(url, "_blank");
                    }}
                >
                    {text}
                </span>
            )
        },
        { title: "Movement Type", dataIndex: "movementType", key: "movementType", width: 120, align: "center" },
        { title: "Status", dataIndex: "status", key: "status", width: 140, align: "center" },
        { title: "Customer", dataIndex: "customer", key: "customer", width: 150, align: "center" },
        { title: "Document Type", dataIndex: "documentType", key: "documentType", width: 120, align: "center" },
        { title: "Service Type", dataIndex: "serviceType", key: "serviceType", width: 120, align: "center" },
        { title: "Travel Type", dataIndex: "travelType", key: "travelType", width: 120, align: "center" },
        { title: "Origin Hub", dataIndex: "originHub", key: "originHub", width: 150, align: "center" },
        { title: "Current Location", dataIndex: "currentLocation", key: "currentLocation", width: 150, align: "center" },
        { title: "Next Location", dataIndex: "nextLocation", key: "nextLocation", width: 150, align: "center" },
        { title: "Destination Hub", dataIndex: "destinationHub", key: "destinationHub", width: 150, align: "center" },
        { title: "Latest Status Time", dataIndex: "latestStatusTime", key: "latestStatusTime", width: 160, align: "center" },
        { title: "Origin Inscan", dataIndex: "originHubInscanAt", key: "originHubInscanAt", width: 160, align: "center" },
        { title: "Origin Outscan", dataIndex: "originHubOutscanAt", key: "originHubOutscanAt", width: 160, align: "center" },
        { title: "Dest Inscan", dataIndex: "destinationHubInscanAt", key: "destinationHubInscanAt", width: 160, align: "center" },
        { title: "Outscan To Dest CP", dataIndex: "outscanToDestinationCpAt", key: "outscanToDestinationCpAt", width: 160, align: "center" },
        { title: "Inscan By Dest CP", dataIndex: "inscanByDestinationCpAt", key: "inscanByDestinationCpAt", width: 160, align: "center" },
        { title: "First Attempt Time", dataIndex: "firstAttemptTime", key: "firstAttemptTime", width: 160, align: "center" },
        { title: "From Pincode", dataIndex: "fromPincode", key: "fromPincode", width: 100, align: "center" },
        { title: "From City", dataIndex: "fromCity", key: "fromCity", width: 120, align: "center" },
        { title: "From State", dataIndex: "senderState", key: "senderState", width: 120, align: "center" },
        { title: "To Pincode", dataIndex: "toPincode", key: "toPincode", width: 100, align: "center" },
        { title: "To City", dataIndex: "toCity", key: "toCity", width: 120, align: "center" },
        { title: "To State", dataIndex: "toState", key: "toState", width: 120, align: "center" },
        { title: "Delivery Attempts", dataIndex: "deliveryAttempts", key: "deliveryAttempts", width: 120, align: "center" },
        { title: "Shipment Value", dataIndex: "shipmentValue", key: "shipmentValue", width: 120, align: "center" },
        { title: "Length", dataIndex: "bookingLength", key: "bookingLength", width: 80, align: "center" },
        { title: "Width", dataIndex: "bookingWidth", key: "bookingWidth", width: 80, align: "center" },
        { title: "Height", dataIndex: "bookingHeight", key: "bookingHeight", width: 80, align: "center" },
        { title: "Weight (kg)", dataIndex: "weightInKg", key: "weightInKg", width: 100, align: "center" },
        { title: "Last Undelivered Reason", dataIndex: "lastUndeliveredReason", key: "lastUndeliveredReason", width: 180, align: "center" },
        { title: "Is Closed", dataIndex: "isClosed", key: "isClosed", width: 100, align: "center", render: val => val }, // API returns "YES"/"NO" string
        // Sevasetu
        { title: "Sevasetu Location", dataIndex: "currentLocationSevasetu", key: "currentLocationSevasetu", width: 150, align: "center" },
        { title: "Sevasetu Status", dataIndex: "currentStatusSevasetu", key: "currentStatusSevasetu", width: 150, align: "center" },
        { title: "Sevasetu Outscan", dataIndex: "outscanToSevasetu", key: "outscanToSevasetu", width: 150, align: "center" },
        { title: "Sevasetu Time", dataIndex: "statusTimeSevasetu", key: "statusTimeSevasetu", width: 160, align: "center" },
        { title: "Remarks", dataIndex: "remarks", key: "remarks", width: 150, align: "center" },
        { title: "Last DRS Number", dataIndex: "lastDrsNumber", key: "lastDrsNumber", width: 150, align: "center" },
        { title: "Last DRS Created On", dataIndex: "lastDrsCreatedOn", key: "lastDrsCreatedOn", width: 150, align: "center" },
        { title: "Last Terminal Status", dataIndex: "lastTerminalStatus", key: "lastTerminalStatus", width: 150, align: "center" },
        { title: "Last Terminal Status Time", dataIndex: "lastTerminalStatusTime", key: "lastTerminalStatusTime", width: 200, align: "center" },
    ];

    return (
        <div className="report-container">
            <div style={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "8px" }}>
                <Heading title="Control Tower Reports"></Heading>
            </div>
            <Card className="report-card">
                <Row gutter={[16, 16]} className="filters-section">
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Booking Date</div>
                        <CalendarComponent
                            type="range"
                            value={dateRange}
                            onChange={(value) => {
                                setDateRange(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            format="YYYY-MM-DD"
                            allowClear
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Latest Status Date</div>
                        <CalendarComponent
                            type="range"
                            value={latestStatusDateRange}
                            onChange={(value) => {
                                setLatestStatusDateRange(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            format="YYYY-MM-DD"
                            allowClear
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Origin Hub</div>
                        <DropDownComponent
                            className="small-dropdown"
                            placeholder="Select Origin Hub"
                            options={hubList}
                            onChange={(value) => {
                                setSelectedOriginHubs(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            value={selectedOriginHubs}
                            loading={hubListLoading}
                            allowClear
                            mode="multiple"
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Destination Hub</div>
                        <DropDownComponent
                            className="small-dropdown"
                            placeholder="Select Destination Hub"
                            options={hubList}
                            onChange={(value) => {
                                setSelectedDestinationHubs(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            value={selectedDestinationHubs}
                            loading={hubListLoading}
                            allowClear
                            mode="multiple"
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Current Location</div>
                        <DropDownComponent
                            className="small-dropdown"
                            placeholder="Select Current Location"
                            options={currentHubOptions}
                            disabled={hubUser === "ROLE_HUBADMIN" || hubUser === "ROLE_HUBOPERATOR"}
                            onChange={(value) => {
                                setSelectedCurrentHubs(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            value={selectedCurrentHubs}
                            loading={loadingCurrentHubs}
                            allowClear
                            mode="multiple"
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                            maxTagCount="responsive"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Status</div>
                        <DropDownComponent
                            className="small-dropdown"
                            placeholder="Select Status"
                            options={statusOptions}
                            onChange={(value) => {
                                setSelectedStatus(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            value={selectedStatus}
                            allowClear
                            mode="multiple"
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                            maxTagCount="responsive"
                        />
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Movement Type</div>
                        <DropDownComponent
                            className="small-dropdown"
                            placeholder="Select Movement Type"
                            options={[
                                { label: "FORWARD", value: "FORWARD" },
                                { label: "REVERSE", value: "REVERSE" }
                            ]}
                            onChange={(value) => {
                                setMovementType(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            value={movementType}
                            allowClear
                            mode="multiple"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Service Type</div>
                        <DropDownComponent
                            className="small-dropdown"
                            placeholder="Select Service Type"
                            options={serviceTypeOptions}
                            onChange={(value) => {
                                setSelectedServiceTypes(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            value={selectedServiceTypes}
                            allowClear
                            mode="multiple"
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                            maxTagCount="responsive"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Is Closed</div>
                        <DropDownComponent
                            className="small-dropdown"
                            placeholder="Select Is Closed"
                            options={[
                                { label: "YES", value: "yes" },
                                { label: "NO", value: "no" },
                                { label: "STANDBY", value: "standby" }
                            ]}
                            onChange={(value) => {
                                setIsClosed(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            value={isClosed}
                            allowClear
                            mode="multiple" // Allowing multiple for UI consistency but API might take one. Logic in params takes `isClosed[0]`
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Last Terminal Status Time</div>
                        <CalendarComponent
                            type="range"
                            value={lastTerminalStatusDateRange}
                            onChange={(value) => {
                                setLastTerminalStatusDateRange(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            format="YYYY-MM-DD"
                            allowClear
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Last Terminal Status</div>
                        <DropDownComponent
                            className="small-dropdown"
                            placeholder="Select Last Terminal Status"
                            options={[
                                { label: "DELIVERED", value: "DELIVERED" },
                                { label: "RTO_DELIVERED", value: "RTO_DELIVERED" }
                            ]}
                            onChange={(value) => {
                                setSelectedLastTerminalStatuses(value);
                                setPagination(prev => ({ ...prev, current: 1 }));
                            }}
                            value={selectedLastTerminalStatuses}
                            allowClear
                            mode="multiple"
                        />
                    </Col>


                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">&nbsp;</div>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            onClick={handleDownload}
                            loading={downloadLoading}
                            style={{ width: "100%" }}
                        >
                            Download Report
                        </Button>
                    </Col>
                </Row>
            </Card>
            <Spin spinning={loading}>
                <TableComponent
                    columns={columns}
                    dataSource={reportData}
                    loading={false}
                    pagination={pagination}
                    onChange={handleTableChange}
                    scroll={{ y: "calc(100vh - 300px)", x: "max-content" }}
                    sticky
                />
            </Spin>
        </div>
    );
};

export default ControlTowerReportsNew;
